import { createSelector } from 'reselect'

const deleteCurrentFolderConfirmSelector = createSelector(
	[state => state.libraries.current],
	current => ({
		libraryUID: current.libraryUID,
		folderUID: current.folderUID,
	})
)

export default deleteCurrentFolderConfirmSelector
